module.exports = __webpack_public_path__ + "static/media/18-10.0b8bb16d.mp3";